module.exports = __webpack_public_path__ + "static/group-6@2x-a902ce8479d70cc10eb596a58fe7c6b8.png";